import {combineReducers} from "@reduxjs/toolkit";
import {reducer as formReducer} from "redux-form";
import {reducer as tenantReducer} from "src/slices/tenant";
import {reducer as userReducer} from "src/slices/user";
import {reducer as orderReducer} from "src/slices/order";
import {reducer as errorsReducer} from "src/slices/errors";
import {reducer as certificateReducer} from "src/slices/certificate";
import {reducer as certificateCsrReducer} from "src/slices/certificate/csr";
import {reducer as productReducer} from "src/slices/product";
import {reducer as organizationReducer} from "src/slices/organization";

const rootReducer = combineReducers({
    form: formReducer,
    tenant: tenantReducer,
    user: userReducer,
    order: orderReducer,
    errors: errorsReducer,
    certificate: certificateReducer,
    certificateCsr: certificateCsrReducer,
    product: productReducer,
    organization: organizationReducer
});

export default rootReducer;
